module.exports = __webpack_public_path__ + "static/media/Add_to_Apple_Wallet.15b0f130.svg";